import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { FeatureFlagEffects } from './feature-flag.effects';
import { featureFlagReducer } from './feature-flag.reducer';

/**
 * Standalone providers for the `featureFlags` NgRx feature slice (SEOMS-437).
 * Replaces the former `FeatureFlagStoreModule`.
 */
export function provideFeatureFlagStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState('featureFlags', featureFlagReducer),
    provideEffects([FeatureFlagEffects]),
  ]);
}
